// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__ncPNA","text":"SelectPayment_text__3SSsW","title":"SelectPayment_title__1Cbjf","btn":"SelectPayment_btn__KkcNh"};